import { HOME_SAVE_TOKEN_FROM_ORGANIZATION } from './constants';

export function saveTokenFromOrganization() {
  return {
    type: HOME_SAVE_TOKEN_FROM_ORGANIZATION,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_SAVE_TOKEN_FROM_ORGANIZATION:
      return {
        ...state,
        token: action.token,
      };

    default:
      return state;
  }
}
